module.exports = __webpack_public_path__ + "images/5c26b809.jpg";